<a href="https://api.whatsapp.com/send?phone=5491136694805&text=Hola,%20me%20gustaría%20averiguar%20por%20un%20servicio." target="_blank" rel="noopener">
  <i class="lni-whatsapp"></i>
</a>
